(() => {
  'use strict';
  if (customElements.get('mobile-product-buy')) return;
  customElements.define('mobile-product-buy', class extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.quantity = this.form?.querySelector('[name="quantity"]');
      this.primary = this.form?.querySelector('[name="add"]');
      if (!this.quantity || !this.primary || !this.form.requestSubmit) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = matchMedia('(max-width:700px)');
      this.submit = this.querySelector('[data-sticky-submit]');
      this.queue = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
      };
      this.addEventListener('click', event => {
        const stepper = event.target.closest('[data-sticky-step]');
        if (stepper && !stepper.disabled) {
          if (stepper.dataset.stickyStep === '1') this.quantity.stepUp(); else this.quantity.stepDown();
          this.quantity.dispatchEvent(new Event('input', { bubbles: true }));
          this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
          this.sync();
        }
        if (event.target.closest('[data-sticky-edit-quantity]')) this.reveal(this.quantity);
        if (event.target.closest('[data-sticky-options]')) this.reveal(this.form.closest('.product-page')?.querySelector('[data-product-variant-select]') || this.form.querySelector('select') || this.quantity);
        if (event.target.closest('[data-sticky-submit]') && !this.primary.disabled) {
          if (!this.form.checkValidity()) { this.reveal(this.form.querySelector(':invalid')); this.form.reportValidity(); return; }
          // The original form owns variant, plan, properties and the single cart request.
          this.form.requestSubmit(this.primary);
        }
      }, options);
      this.form.addEventListener('input', this.queue, options);
      this.form.addEventListener('change', this.queue, options);
      document.addEventListener('beerclub:cart-updated', this.queue, options);
      document.addEventListener('beerclub:header-visibility-change', this.queue, options);
      document.addEventListener('focusin', this.queue, options);
      document.addEventListener('focusout', this.queue, options);
      window.addEventListener('scroll', this.queue, { ...options, passive: true });
      window.addEventListener('resize', this.queue, options);
      window.visualViewport?.addEventListener('resize', this.queue, options);
      this.mobile.addEventListener('change', this.queue, options);
      this.observer = new MutationObserver(this.queue);
      this.observer.observe(this.form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'hidden', 'min', 'max', 'step', 'value'] });
      this.resizeObserver = new ResizeObserver(this.queue);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.form);
      this.sync();
    }
    reveal(field) {
      if (!field) return;
      field.scrollIntoView({ block: 'center', behavior: 'instant' });
      field.focus({ preventScroll: true });
      this.sync();
    }
    sync() {
      if (!this.isConnected || !this.primary) return;
      const qty = Number(this.quantity.value);
      const min = Number(this.quantity.min || 1), step = Number(this.quantity.step || 1);
      const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
      const locked = this.primary.disabled || this.quantity.disabled;
      const valid = this.quantity.value !== '' && this.quantity.validity.valid;
      this.querySelector('[data-sticky-edit-quantity]').textContent = valid ? this.quantity.value : '—';
      this.querySelector('[data-sticky-edit-quantity]').setAttribute('aria-label', 'Editar quantidade: ' + (valid ? this.quantity.value : 'confira o valor'));
      this.querySelector('[data-sticky-step="-1"]').disabled = locked || (valid && qty - step < min);
      this.querySelector('[data-sticky-step="1"]').disabled = locked || (valid && qty + step > max);
      this.submit.disabled = locked;
      this.querySelector('[data-sticky-label]').textContent = this.primary.hasAttribute('data-cart-locked') ? 'Adicionando…' : this.primary.disabled ? 'Indisponível' : 'Comprar';
      this.querySelector('[data-sticky-total]').textContent = this.form.querySelector('[data-purchase-total]')?.textContent || '';
      const installments = this.form.querySelector('[data-purchase-installments]');
      this.querySelector('[data-sticky-installments]').textContent = installments && !installments.hidden ? installments.textContent.trim() : '';
      const variant = this.form.closest('.product-page')?.querySelector('[data-product-variant-select] option:checked');
      const plan = this.form.querySelector('[name="selling_plan"] option:checked');
      this.querySelector('[data-sticky-selection]').textContent = variant || plan ? 'Rever opções ↑' : (qty > 1 ? 'Total para ' + qty + ' unidades' : 'Rever produto ↑');
      const header = document.querySelector('.header');
      const headerOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--bc-header-offset'));
      const headerBottom = Number.isFinite(headerOffset) ? headerOffset : header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const keyboard = window.visualViewport && innerHeight - window.visualViewport.height > 150;
      const editing = document.activeElement?.matches('input,select,textarea,[contenteditable="true"]');
      const visible = this.mobile.matches && !keyboard && !editing && this.primary.getBoundingClientRect().bottom <= headerBottom;
      // Do not remove a focused action while keyboard navigation stays within the bar.
      const keyboardFocus = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
      this.hidden = !(visible || (this.mobile.matches && keyboardFocus));
      document.body.classList.toggle('has-mobile-product-buy', !this.hidden);
      if (!this.hidden && this.offsetHeight) document.body.style.setProperty('--mobile-buy-space', this.offsetHeight + 'px');
    }
    disconnectedCallback() {
      this.controller?.abort(); this.observer?.disconnect(); this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      document.body.classList.remove('has-mobile-product-buy');
      document.body.style.removeProperty('--mobile-buy-space');
    }
  });
})();
